import axios from "axios";
import authHeader from "../helpers/header";
import helper from "../helpers/query";
import apiInstance from "./api";

import { API_URL, NODE_URL, EXCLUDE_TAGS } from "../configs";

// create resource
const createResource = (data) => {
  let tags = [];
  let list = [];
  //prrocess tag name
  if (data.tags !== "") {
    list = data.tags.split(",");
    //generate tag base on name of resource
  } else {
    list = data.name.split(" ");
  }
  //process tags data
  for (let i = 0; i < list.length; i++) {
    let new_tag = list[i].trim().replace(/[^\w\s]/gi, "");
    //exclude unuse words and check if it is duplicated
    if (!EXCLUDE_TAGS.includes(list[i].trim()) && tags.indexOf(new_tag) < 0) {
      tags.push({ name: new_tag });
    }
  }

  // Fix price precision: round to 2 decimals if present
  let price = data.price;
  if (typeof price === 'number') {
    price = Math.round((price + Number.EPSILON) * 100) / 100;
  } else if (typeof price === 'string' && price !== '') {
    price = Math.round((parseFloat(price) + Number.EPSILON) * 100) / 100;
  }

  return apiInstance.post(
    API_URL + "resources",
    {
      name: data.name,
      description: data.description,
      license: data.license,
      status: data.status,
      price: price,
      categories: data.categories,
      tags: tags,
      images: data.images,
      mainImage: data.mainImage,
    },
    { headers: authHeader(), withCredentials: true }
  );
};

// get resource by slug
const getResourceBySlug = (slug) => {
  return apiInstance.get(API_URL + `resources/${slug}`, { withCredentials: true, headers: authHeader() });
};
// get resource by id
const getResourceById = (id) => {
  return apiInstance.get(API_URL + `resources/by_id/${id}`, { withCredentials: true, headers: authHeader() });
};

// get rejection reason by id
const getRejectionReasonById = (id) => {
  return apiInstance.get(API_URL + `resources/rejection/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
};

// change delete method to update status
const removeResource = (id) => {
  return apiInstance.delete(API_URL + `resources/${id}`, { withCredentials: true, headers: authHeader() });
};

// change delete method to update status
const bulkUpdateResource = (data) => {
  return apiInstance.post(
    API_URL + `resources/bulkUpdate`,
    {
      data,
    },
    { headers: authHeader(), withCredentials: true }
  );
};

// change delete method to update status
const bulkUpdateResourceMeta = (data) => {
  return apiInstance.post(
    API_URL + `resources/bulkUpdateMeta`,
    {
      data,
    },
    { headers: authHeader(), withCredentials: true }
  );
};

// get related tag by tag name
const getRelatedTag = (tag) => {
  return apiInstance.get(API_URL + `resources/related_tags/${tag}`, { withCredentials: true, headers: authHeader() });
};

/**
 * generate resource color by resource id
 * @param {str} id
 * @returns json data
 */
const generateResourceThumbnail = (id) => {
  return apiInstance.get(API_URL + `datas/thumbnail/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
};

/**
 * generate resource color by resource id
 * @param {str} id
 * @returns json data
 */
const generateResourceColors = (id) => {
  return apiInstance.get(API_URL + `datas/colors/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
};

/**
 * generate resource data by resource id
 * @param {str} id
 * @returns json data
 */
const generateResourceData = (id) => {
  return apiInstance.get(API_URL + `datas/regenerate/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
};

/**
 * generate resource meta by resource id
 * @param {str} id
 * @returns json data
 */
const generateResourceMeta = (id) => {
  return apiInstance.get(API_URL + `datas/meta/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
};

/**
 * Get simlar resources by resource id
 * @param {str} id
 * @returns
 */
const getSimilarResourceById = (id) => {
  //return apiInstance.get(API_URL + `resources/similar/${id}`);
  return apiInstance.get(API_URL + `collections/by_resource_id/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
};

/**
 * Get simlar resources by resource id
 * @param {str} id
 * @returns
 */
const getSameCollectionbyResourceId = (id) => {
  return apiInstance.get(API_URL + `collections/by_resource_id/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
};

// update resource data
const updateResource = (id, resource) => {
  let tags = [];
  //process tags data
  for (let i = 0; i < resource.tags.length; i++) {
    //exclude unuse words
    if (!EXCLUDE_TAGS.includes(resource.tags[i].name.trim())) {
      tags.push({
        name: resource.tags[i].name.trim().replace(/[^\w\s]/gi, ""),
      });
    }
  }
  // Ensure is_picked is always boolean
  let isPickedValue = resource.is_picked;
  if (typeof isPickedValue === 'string') {
    isPickedValue = isPickedValue === 'true';
  } else {
    isPickedValue = Boolean(isPickedValue);
  }

  
  const data =
    resource.status === "reject"
      ? {
          name: resource.name,
          description: resource.description,
          license: resource.license,
          status: resource.status,
          price: resource.price,
          new_date: resource.new_date,
          scheduled_at: resource.scheduled_at,
          slug: resource.slug,
          is_picked: isPickedValue,
          rejection_reason:
            resource.rejection_reason === "other"
              ? resource.other_reasons
              : resource.rejection_reason,
          tags: tags,
          images: resource.images,
          mainImage: resource.mainImage,
          metaSeo: {
            metaTitle: resource.meta_title,
            metaDescription: resource.meta_description,
            metaKeywords: resource.meta_keywords,
            canonicalURL: resource.meta_canonicalURL,
            redirectURL: resource.meta_redirectURL,
          },
        }
      : {
          name: resource.name,
          description: resource.description,
          license: resource.license,
          status: resource.status,
          new_date: resource.new_date,
          scheduled_at: resource.scheduled_at,
          price: resource.price,
          slug: resource.slug,
          is_picked: isPickedValue,
          tags: tags,
          images: resource.images,
          mainImage: resource.mainImage,
          metaSeo: {
            metaTitle: resource.meta_title,
            metaDescription: resource.meta_description,
            metaKeywords: resource.meta_keywords,
            canonicalURL: resource.meta_canonicalURL,
            redirectURL: resource.meta_redirectURL,
          },
        };
  console.log("update resource data", data);
  return apiInstance.patch(API_URL + `resources/${id}`, data, {
    headers: authHeader(),
    withCredentials: true,
  });
};

// get all resource base condition
const getAllResources = async (query) => {
  // Build query
  let newQuery = {};

  if (query.q) {
    newQuery.q = query.q;
  } else {
    newQuery.q = "";
  }

  if (query.tags) {
    newQuery.tags = decodeURI(query.tags).replaceAll(" ", "+");
  }

  if (query.category) {
    newQuery.category = query.category;
  }

  if (query.preview) {
    newQuery.preview = query.preview;
  }

  if (query.created_by) {
    newQuery.created_by = query.created_by;
  }

  if (query.created_from) {
    newQuery.created_from = query.created_from;
  }

  if (query.created_to) {
    newQuery.created_to = query.created_to;
  }


  if (query.status) {
    newQuery.status = query.status;
  }

  if (query.license) {
    newQuery.license = query.license;
  }

  if (query.has_color) {
    newQuery.has_color = query.has_color; // Include has_color in the query
  }

  if (query.exclude_in_collection) {
    newQuery.exclude_in_collection = query.exclude_in_collection; // Include exclude_in_collection in the query
  }

  if (query.color) {
    newQuery.color = query.color; // Include color in the query
  }

  if (query.page) {
    newQuery.offset = parseInt(query.page) - 1;
  }

  if (query.pageSize) {
    newQuery.limit = parseInt(query.pageSize);
  }

  if (query.sortby) {
    newQuery.sortby = query.sortby;
  }

  if (query.direction) {
    newQuery.direction = query.direction;
  }

  let q = helper.arrayToQueryString(newQuery);
  const response = await apiInstance.get(API_URL + `resources/?${q}`, {
    headers: authHeader(),
    withCredentials: true,
  });
  return response.data;
};

// get resource categories list from resouce data
// const getCategories = () => {
//   return axios.get(API_URL + `resources/categories/all`);
// };

// const limit = (count, p) => `limit=${count}&offset=${p}`;
// //const omitSlug = article => Object.assign({}, article, { slug: undefined })
// const getAll = (page, limit = 5) => {

//   let url = '';
//   //if(parseInt(page-1) === 0) {
//   url = API_URL + `resources?limit=${limit}&offset=${(parseInt(page) - 1) * limit}`
//   // }else{
//   //   url = API_URL+`resources?limit=${limit}&offset=${parseInt(page-1)*limit}`
//   // }
//   console.log(url)
//   return axios.get(url)
// }

const generateResourcesInfoWithGemini = async (data) => {
  return axios.post(
    NODE_URL + `/api/resources/generate/gemini`,
    data
    // { headers: authHeader() }
  );
};

const generateResourcesInfoWithOpenai = async (data) => {
  return axios.post(
    NODE_URL + `/api/resources/generate/openai`,
    data
    // { headers: authHeader() }
  );
};

const regenerateWithOpenai = async (data) => {
  return axios.post(
    NODE_URL + `/api/resources/regenerate/openai`,
    {
      ...data,
    }
    // { headers: authHeader() }
  );
};

const regenerateWithGemini = async (data) => {
  return axios.post(
    NODE_URL + `/api/resources/regenerate/gemini`,
    {
      ...data,
    }
    // { headers: authHeader() }
  );
};

const getMergeImgeBase64 = async (data) => {
  return axios.post(
    NODE_URL + `/api/resources//merge-thumbnail`,
    {
      ...data,
    }
    // { headers: authHeader() }
  );
};

// Export resources to CSV
const exportResourcesCSV = async (resourceIds) => {
  const resourcesIdParam = resourceIds.join(',');
  const response = await apiInstance.get(
    API_URL + `resources/export/csv?resourcesId=${resourcesIdParam}`,
    {
      headers: authHeader(),
      withCredentials: true,
      responseType: 'blob' // Important for file download
    }
  );
  
  // Create download link
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  
  // Extract filename from response headers or create default with timestamp
  const contentDisposition = response.headers['content-disposition'];
  let filename = `resource_${new Date().toISOString().slice(0, 19).replace(/[-:]/g, '').replace('T', '_')}.csv`;
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
    if (filenameMatch) {
      filename = filenameMatch[1];
    }
  }
  
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  
  return response;
};

// Detect ContentType from uploaded files
const detectContentType = (resourceId) => {
  return apiInstance.post(
    API_URL + `resources/${resourceId}/detect_content_type`,
    {},
    { headers: authHeader(), withCredentials: true }
  );
};

const exportedObject = {
  createResource,
  updateResource,
  removeResource,
  //getAll,
  getAllResources,
  getResourceBySlug,
  getResourceById,
  getRejectionReasonById,
  getSimilarResourceById,
  getSameCollectionbyResourceId,
  //getCategories,
  bulkUpdateResource,
  bulkUpdateResourceMeta,
  getRelatedTag,
  generateResourceColors,
  generateResourceData,
  generateResourceThumbnail,
  generateResourceMeta,
  // generate with ai
  generateResourcesInfoWithGemini,
  generateResourcesInfoWithOpenai,
  regenerateWithOpenai,
  regenerateWithGemini,
  getMergeImgeBase64,
  exportResourcesCSV,
  detectContentType,
};

export default exportedObject;
